import React, { FC, memo, ReactNode } from 'react';
import { getPlatformStyles, isMobile } from '@direct-frontend/platform-code';

import { HStack, VStack } from '../Stack';
import { ColorlessIconProps, IconSize } from '../../icons/types';
import { cn } from '../../lib/css/className/className';

import { InfoColor, InfoColorConfig } from './types';
import { createInfoColorConfig } from './utils';

getPlatformStyles({
    common: import('./InfoBase.css'),
});

const cls = cn('InfoBaseIcon');

export interface InfoBaseIconProps {
    /**
     * Компонент иконки (опционален, если передан color)
     */
    icon?: FC<ColorlessIconProps>;

    /**
     * Размер иконки
     */
    iconSize: IconSize;

    /**
     * Цвет для автоматического выбора иконки
     */
    color?: InfoColor;

    /**
     * Конфигурация цветов (для кастомных иконок)
     */
    colorConfig?: InfoColorConfig;

    /**
     * CSS класс для контейнера
     */
    className?: string;

    /**
     * CSS класс для иконки
     */
    iconClassName?: string;

    /**
     * Дополнительные классы для вертикального выравнивания
     */
    addonClasses?: string;

    /**
     * Компонент лейбла (отображается справа на мобильных)
     */
    labelBlock?: ReactNode;
}

/**
 * Компонент для отображения блока с иконкой в информационных компонентах.
 */
export const InfoBaseIcon = memo<InfoBaseIconProps>(function InfoBaseIcon({
    icon,
    iconSize,
    color,
    colorConfig,
    className,
    iconClassName,
    addonClasses,
    labelBlock,
}) {
    const config = colorConfig || createInfoColorConfig();
    const IconComponent = icon || (color ? config.icons[color] : config.icons.island);

    return (
        <HStack className={cls(null, [className])} justifyContent="space-between">
            <VStack className={addonClasses}>
                <IconComponent size={iconSize} className={iconClassName} />
            </VStack>
            <VStack className={addonClasses}>{isMobile() && labelBlock}</VStack>
        </HStack>
    );
});
